<!-- @format -->
<!-- Basic loader of a field -->
<template>
    <v-progress-linear
        indeterminate
        :color="color"
        rounded
        :height="height"
        class="mt-6 mb-2"
        :class="props.class"
    ></v-progress-linear>
</template>
<script setup>
const props = defineProps({
    color: {
        type: String,
        default: 'grey-darken-2'
    },
    height: {
        type: String,
        default: '64px'
    },
    class: {
        type: String,
        default: ''
    }
})
</script>
